/**
 * Modal displayed when a note is fully subscribed (409 error)
 */

import { FC } from "react";
import { Modal, Text } from "@mantine/core";
import { LargeBtn, color } from "@funded-here-interface/common";
import { FULLY_SUBSCRIBED_MESSAGES, COLORS } from "./constants";

interface FullySubscribedModalProps {
  opened: boolean;
  onClose: () => void;
  onBrowseNotes?: () => void;
}

const FullySubscribedModal: FC<FullySubscribedModalProps> = ({
  opened,
  onClose,
  onBrowseNotes,
}) => {
  return (
    <Modal
      centered
      size="sm"
      overlayProps={{
        blur: 3,
        opacity: 0.1,
      }}
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
    >
      <div style={{ marginTop: 20, marginBottom: 5 }}>
        <Text
          style={{
            fontSize: "20px",
            fontWeight: 700,
            marginBottom: "16px",
          }}
        >
          {FULLY_SUBSCRIBED_MESSAGES.TITLE}
        </Text>
        <Text
          style={{
            fontSize: "14px",
            marginBottom: "24px",
          }}
        >
          {FULLY_SUBSCRIBED_MESSAGES.BODY}
        </Text>
        <div style={{ display: "flex", gap: "12px" }}>
          <LargeBtn
            onClick={onClose}
            backgroundColor={COLORS.SECONDARY_BG}
            textColor={COLORS.SECONDARY_TEXT}
            width="50%"
          >
            Okay
          </LargeBtn>
          {onBrowseNotes && (
            <LargeBtn
              onClick={onBrowseNotes}
              backgroundColor={color.FHGREEN}
              textColor="#FFFFFF"
              width="50%"
            >
              Browse Notes
            </LargeBtn>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FullySubscribedModal;
